import { createRootRoute, createRoute } from '@tanstack/react-router';

import { ApiError } from '@/models/ApiErrorData.ts';
import { HandledErrorPage } from '@/pages/HandledErrorPage.tsx';
import { QATools } from '@/pages/QaTools/QaTools';
import { PractitionerAccountPage } from '@/pages/account/PractitionerAccountPage.tsx';
import { MeasurementImportPage } from '@/pages/add-measurement/MeasurementImportPage';
import { PractitionerLayout } from '@/pages/layout/PractitionerLayout.tsx';
import { PractitionerManagePatientLayout } from '@/pages/layout/PractitionerManagePatientLayout.tsx';
import { PatientMedicalFile } from '@/pages/patient-medical-file/PatientMedicalFile';
import { PatientMonitoring } from '@/pages/patient-monitoring/PatientMonitoring';
import { PatientSettings } from '@/pages/patient-settings/PatientSettings';
import { PatientsPage } from '@/pages/patients/PatientsPage';

const practitionerRootRoute = createRootRoute({
  component: PractitionerLayout,
  errorComponent: HandledErrorPage,
  notFoundComponent: () => (
    <HandledErrorPage
      error={new ApiError({ error: 'PAGE_NOT_FOUND', statusCode: 0 })}
      reset={() => {}}
    />
  ),
});

const patientLayoutRoute = createRoute({
  getParentRoute: () => practitionerRootRoute,
  path: 'patients/$id',
  component: PractitionerManagePatientLayout,
  errorComponent: HandledErrorPage,
  notFoundComponent: () => (
    <HandledErrorPage
      error={new ApiError({ error: 'PAGE_NOT_FOUND', statusCode: 0 })}
      reset={() => {}}
    />
  ),
});

export const practitionerRoutes = {
  index: createRoute({
    getParentRoute: () => practitionerRootRoute,
    path: '/',
    component: PatientsPage,
  }),
  patientList: createRoute({
    getParentRoute: () => practitionerRootRoute,
    path: 'patients',
    component: PatientsPage,
  }),
  account: createRoute({
    getParentRoute: () => practitionerRootRoute,
    path: 'account',
    component: PractitionerAccountPage,
  }),
  patientMonitoring: createRoute({
    getParentRoute: () => patientLayoutRoute,
    path: '/',
    component: PatientMonitoring,
  }),
  patientMedicalFile: createRoute({
    getParentRoute: () => patientLayoutRoute,
    path: 'medical-file',
    component: PatientMedicalFile,
  }),
  patientSettings: createRoute({
    getParentRoute: () => patientLayoutRoute,
    path: 'settings',
    component: PatientSettings,
  }),
  patientUploadData: createRoute({
    getParentRoute: () => patientLayoutRoute,
    path: 'upload-data',
    component: MeasurementImportPage,
  }),
  qaTools: createRoute({
    getParentRoute: () => patientLayoutRoute,
    path: 'patient-management',
    component: QATools,
  }),
};

export const practitionerRouteTree = practitionerRootRoute.addChildren([
  practitionerRoutes.index,
  practitionerRoutes.patientList,
  practitionerRoutes.account,
  patientLayoutRoute.addChildren([
    practitionerRoutes.patientMonitoring,
    practitionerRoutes.patientMedicalFile,
    practitionerRoutes.patientSettings,
    practitionerRoutes.patientUploadData,
    practitionerRoutes.qaTools,
  ]),
]);
